import TileMap from '../models/tileMap.js';

export default class TileMapBinarySerialiser {


    /**
     * Serialises the tile set to a planar byte array.
     * @param {TileMap} tileMap - Tile set to serialise.
     * @returns {number[]}
     */
    static serialise(tileMap) {
        throw new Error('This method is not implemented.');
    }


}